const PaymentModal = ({
  walletBalance,
  onWalletPayment,
  onStripePayment,
  onClose,
  walletPaymentLoading,
  stripePaymentLoading
}) => {
  return (
    <div className="payment-modal-overlay">
      <div className="payment-modal">

        <button
          className="payment-modal-close"
          onClick={onClose}
        >
          ×
        </button>

        <h3>Choose Payment Method</h3>

        <p className="payment-modal-balance">
          Wallet Balance: <strong>Rs. {Number(walletBalance).toLocaleString()}</strong>
        </p>

        <p className="payment-modal-text">
          How would you like to pay for this job?
        </p>

        <div className="payment-modal-buttons">

          <button
            type="button"
            onClick={onWalletPayment}
            disabled={walletPaymentLoading}
          >
            {walletPaymentLoading ? "Processing..." : "💰 Pay from Wallet"}
          </button>


          <button
            type="button"
            onClick={onStripePayment}
            disabled={stripePaymentLoading}
          >
            {stripePaymentLoading ? "Processing..." : "💳 Pay with Stripe"}
          </button>

        </div>

      </div>
    </div>
  );
};

export default PaymentModal;